<template>
    <v-container fluid full-height>
        <v-layout justify-center align-center>
            <img src="../../assets/images/home.png" width="100%"/>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "Dashboard",
        data(){
            return {
                source:'http://blur'
            }
        }
    }
</script>

<style scoped>

</style>